<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <b-icon-diagram2 class="mr-1"></b-icon-diagram2>
      {{ $t('page.title.dictionary') }}
    </page-header>
    <div class="card questions sygni-grid">
      <div class="card-header">
        <h3 class="card-title">
          <strong>{{$t('title.list')}} </strong>
        </h3>
        <div class="d-flex card-header-pills float-right">
          <b-button @click="createNewDictModal()" size="sm" variant="success">
            {{$t('btn.add_new')}}
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <div class="row mt-2">
          <div class="col-12">
            <div class="pagination-wrapper justify-content-end">
              <div class="pagination-right">
                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>
              </div> <!-- #pagination-right-->
            </div> <!-- #pagination-wrapper-->

            <div class="table-responsive">
              <b-table striped show-empty
                       :empty-text="$t('table.no_results')"
                       :busy="isBusy"
                       hover
                       head-variant="dark"
                       outlined
                       :sort-by.sync="orderColumn"
                       :sort-desc.sync="orderDirection"
                       :no-local-sorting="true"
                       :items="items"
                       :fields="fields">

                <template #cell(languages)="data">
                  <div class="table-flag--wrapper">
                  <span v-for="(lang, index) in data.value" :key="index">
                      <img :src="`~@/assets/flags/${lang}.svg`" class="table-flags"> {{ lang.toUpperCase() }}
                  </span>
                  </div>
                </template>

                <template #cell(aliasId)="data">
                  <div>{{data.item.alias}}</div>
                </template>

                <template #cell(dates)="data">
                  <div class="table-flag--wrapper">
                    <div>{{ data.item.createdAt | date }}</div>
                    <div>{{ data.item.updatedAt | date }}</div>
                  </div>
                </template>

                <template #cell(categories)="data">
                  <div class="table-categories--wrapper" v-for="(cat, index) in data.value" :key="index">
                    <b-badge variant="light">{{ cat }}</b-badge>
                  </div>
                </template>

                <template #cell(status)="data">
                  <b-badge pill variant="dark" v-if="data.value == 30">DELETED</b-badge>
                  <b-badge pill variant="success" v-if="data.value == 20">PUBLISHED</b-badge>
                  <b-badge pill variant="warning" v-if="data.value == 10">DRAFT</b-badge>
                </template>

                <template #cell(answers)="data">
                  <div class="table--answers">
                    <div v-for="(ans, index) in data.value" :key="index">
                      <b-badge :variant="data.item.correctAnswer === (index+1) ? 'success' : ''">
                        {{ ans }}
                      </b-badge>
                    </div>
                  </div>
                </template>

                <template #cell(actions)="data">
                  <div class="table-action--cell">
                    <b-button variant="primary" size="sm"
                              @click="goTo(data.item)">
                      {{ $t('table.btn.show') }}
                    </b-button>
                    <b-button variant="success" size="sm"
                              @click="editDictionary(data.item)">
                      {{ $t('table.btn.edit') }}
                    </b-button>
                    <b-button variant="danger" size="sm"
                              @click="deleteItem(data.item)">
                      {{ $t('table.btn.delete') }}
                    </b-button>
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>

              </b-table>
            </div> <!-- #table-responsive-->

            <grid-pagination :total-count="totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>

          </div>
        </div>
      </div> <!-- #card-body-->
    </div> <!-- #card questions sygni-grid-->
  </div>
</template>

<script>

import axios from "axios";
import GridMixin from "../../../components/grid/GridMixin";
import Vue from "vue";
import NewDictionaryModal from "../components/DictionaryAddModal";
import DictionaryEditModal from "../components/DictionaryEditModal";
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";
import PageHeader from "../../../components/page/PageHeader";

export default {
  mixins: [GridMixin],
  components: {
    PageHeader,
    GridPagination
  },
  data() {
    return {
      gridGetUrl: '/api/dictionary',
      showDeleted: false,
      orderColumn: 'name',
      orderDirection: true,
      fields: [
        {key: 'alias'},
        {key: 'name', label: this.$t('table.header.name'), sortable: true},
        {key: 'aliasId',  label: this.$t('table.header.alias')},
        {key: 'active', label: this.$t('table.header.status'), sortable: true},
        {key: 'actions', label: this.$t('table.header.actions')},
      ],
      items: [],
    };
  },
  mounted() {
    this.$on('refresh-dict', () => {
      this.loadItems();
    })
  },
  methods: {
    createNewDictModal() {
      const
          ModalConstructor = Vue.extend(NewDictionaryModal),
          modal = new ModalConstructor({parent: this});

      modal.name = 'create-dictionary';
      modal.title = this.$t('modal.title.create_dictionary');

      modal.$mount();
    },
    goTo(item) {
      this.$router.push({name: 'dictionary-entry', params: {entry: item.alias}});
    },
    edit(item) {
      this.$router.push({name: 'dictionary-entry', params: {entry: item.alias}});
    },
    deleteItem: function (item) {
      let _that = this;
      this.$bvModal.msgBoxConfirm(this.$t('modal.title.msg_delete_dictionary')+' '+ item.alias, {
        title: this.$t('modal.title.delete_dictionary'),
        okTitle: this.$t('btn.delete'),
        cancelTitle: this.$t('btn.cancel'),
        okVariant: 'danger',
      })
          .then(value => {
            if (value) {
              axios.delete(`/api/dictionary/${item.alias}`)
                  .then(function () {
                    _that.loadItems();
                  })
                  .catch(error => {
                    console.log(error);
                  });
            }
          });
    },
    editDictionary(dict) {
      const
          ModalConstructor = Vue.extend(DictionaryEditModal),
          modal = new ModalConstructor({parent: this});

      modal.name = 'edit-dict';
      modal.title = this.$t('modal.title.edit_dictionary');
      modal.form = {...dict};

      modal.$mount();
    },
  }
}
</script>
